import dayjs from "dayjs";

export const STATUS_CONFIG = {
  assigned: { label: "Assigned", color: "#48484a", bg: "#eaeaea" },
  checked_in: { label: "Checked In", color: "#4a5d4e", bg: "#e5ebe6" },
  en_route: { label: "En Route", color: "#d15d36", bg: "#f7e6de" },
  arrived: { label: "Arrived", color: "#3d684d", bg: "#e2ede6" },
  completed: { label: "Completed", color: "#ffffff", bg: "#3d684d" },
  delayed: { label: "Delayed", color: "#ffffff", bg: "#b33a3a" },
  cancelled: { label: "Cancelled", color: "#6b6b70", bg: "#e5e5ea" },
};

export const CATEGORY_CONFIG = {
  installation: { label: "Installation", team: "installation", color: "#d15d36", tint: "#f7e6de" },
  delivery: { label: "Delivery", team: "delivery", color: "#3f6f8f", tint: "#e2edf3" },
  measure: { label: "Measure", team: "installation", color: "#7a5c9e", tint: "#efe8f5" },
  service_call: { label: "Service Call", team: "installation", color: "#c38029", tint: "#f7eddd" },
  template: { label: "Template", team: "installation", color: "#4a7c59", tint: "#e3efe7" },
  inspection: { label: "Inspection", team: "installation", color: "#48484a", tint: "#eaeaea" },
  chargeable_service: { label: "Chargeable Service", team: "installation", color: "#48484a", tint: "#eaeaea" },
};

// Categories offered in the Create Job form (per product spec)
export const FORM_CATEGORIES = ["installation", "delivery", "measure", "service_call", "template"];

export const PRIORITY_CONFIG = {
  low: { label: "Low", color: "#899277" },
  normal: { label: "Normal", color: "#48484a" },
  high: { label: "High", color: "#c38029" },
  urgent: { label: "Urgent", color: "#b33a3a" },
};

export const ROLE_LABELS = {
  admin: "Administrator",
  installation_ops: "Installation Ops",
  delivery_ops: "Delivery Ops",
  ops: "Ops",
  driver: "Field Crew",
  am: "Account Manager",
  salesperson: "Account Manager",
  customer: "Customer",
};

export const OPS_ROLES = ["admin", "installation_ops", "delivery_ops", "ops"];

// Ordered pipeline for progress display
export const STATUS_FLOW = ["assigned", "checked_in", "en_route", "arrived", "completed"];

export function fmtDateTime(v) {
  if (!v) return "—";
  return dayjs(v).format("MMM D, YYYY · h:mm A");
}
export function fmtDate(v) {
  if (!v) return "—";
  return dayjs(v).format("MMM D, YYYY");
}
export function fmtTime(v) {
  if (!v) return "—";
  return dayjs(v).format("h:mm A");
}
export function fromNow(v) {
  if (!v) return "";
  return dayjs(v).fromNow();
}
export function isStalePing(v, mins = 5) {
  if (!v) return true;
  return dayjs().diff(dayjs(v), "minute") >= mins;
}
export function kmToMiles(km) {
  return km * 0.621371;
}
export function fmtMiles(km, digits = 1) {
  if (km == null) return "—";
  return `${(km * 0.621371).toFixed(digits)} mi`;
}
export function fmtDuration(min) {
  if (min == null || min === "" || Number(min) <= 0) return null;
  const m = Math.round(Number(min));
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (h && rem) return `${h}h ${rem}m`;
  if (h) return `${h}h`;
  return `${rem}m`;
}
// For datetime-local inputs
export function toLocalInput(v) {
  if (!v) return "";
  return dayjs(v).format("YYYY-MM-DDTHH:mm");
}
